const state = {
    testCases: [],
    testCasesTotalCount: null,
};

const getters = {
    testCases: state => state.testCases,
    testCasesTotalCount: state => state.testCasesTotalCount,
    testCaseById: state => id => {
        return state.testCases.find(item => item.id.toString() === id.toString());
    },
};

const mutations = {
    SET_TEST_CASES(state, testCases) {
        state.testCases = testCases;
    },
    SET_TEST_CASES_TOTAL_COUNT(state, testCasesTotalCount) {
        state.testCasesTotalCount = testCasesTotalCount;
    },
    ADD_TEST_CASE(state, testCase) {
        if (state.testCases.findIndex(item => item.id.toString() === testCase.id.toString()) !== -1) return;
        state.testCases.push(testCase);
    },
    CLEAR_TEST_CASES(state) {
        state.testCases = [];
        state.testCasesTotalCount = 0;
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
